export default [{
  path: '/videoPlay',
  name: 'videoPlay',
  meta: {
    index: 20
  },
  params:{},
  component: () => import('@/views/videoPlay/index'),
}]
